import React from "react";

// Pastille d'état : icône + texte (jamais la couleur seule).
const Pill = ({ tone = "neutral", icon = null, children, className = "", title }) => (
  <span className={`pill pill--${tone} ${className}`.trim()} title={title}>
    {icon && <i className={`fa ${icon}`} aria-hidden="true" />}
    {children}
  </span>
);

export default Pill;
